<template>
	<v-layout column class="turizem-details-wrapper">
		<div v-if="have_images_in_point" :style="set_style">
			<hooper :key="hopper_view_detail" :progress="true" :infiniteScroll="true">
				<!-- Todo Remove this function -->
				<slide v-for="(photo, index) in [getImageArrayTemp()]" :key="index">
					<img :src="photo" alt />
				</slide>
				<hooper-progress slot="hooper-addons"></hooper-progress>
			</hooper>
		</div>
		<div class="container">
			<div v-bind:style="{ 'margin-top': info_or_turisem ? '40px' : '' }" class="turizem-details-content">
				<div class="turizem-details-top">
					<div class="turizem-details-contact">
						<v-icon color="primary">location_on</v-icon>
						<span>{{ detail_data.poi_address }}</span>
					</div>
					<div class="turizem-details-title">{{ detail_data.poi_title }}</div>
				</div>
				<div
					class="turizem-details-description"
					v-bind:style="{ display: info_or_turisem ? 'none' : '' }"
					v-html="detail_data.poi_content"
				></div>
			</div>
			<BaseAccordionController
				class="turizem-details-map-wrapper"
				:expanded="true"
				:expand_accondion="true"
				:accordion_header="getStateWithParam('map')"
			>
				<template v-slot:component>
					<MapCard ref="map_in_turisem_detail" class="accordion-card-middle" :fitbounds="fitbounds">
						<template v-if="getMarkerCoordinates">
							<l-marker :lat-lng="getMarkerCoordinates" :icon="icon_url"></l-marker>
						</template>
					</MapCard>
				</template>
				<template v-slot:icon>
					<v-icon color="primary">map</v-icon>
				</template>
			</BaseAccordionController>
		</div>
	</v-layout>
</template>

<script>
import { Hooper, Slide, Progress as HooperProgress } from 'hooper';
import MapCard from '@/components/cards/MapController.vue';
import { LMarker } from 'vue2-leaflet';
import poi from '@/config/api/api_events/poi.js';
import map_helper from '@/config/js_helper/map_helper.js';
import { latLng } from 'leaflet';

export default {
	name: 'TurisemDetail',
	props: {
		point_id: {
			type: [Number, String],
			required: false,
		},
		info_or_turisem: {
			type: [Boolean],
			required: false,
			default: false,
		},
		icon: {
			type: [String],
			default: require('@/assets/img/new_icons/atraksione.svg'),
			required: false,
		},
	},
	components: {
		Hooper,
		MapCard,
		LMarker,
		Slide,
		HooperProgress,
	},
	data() {
		return {
			hopper_view_detail: 5000,
			expand_accondion: true,
			detail_data: {},
			have_images_in_point: true,
			turisem_point_detail: undefined,
			turizem_point_id: this.point_id,
			from_where: 15,
			icon_url: map_helper.getIcon(this.icon),
			set_style: 'margin-top:0px !important',
			fitbounds: 0,
		};
	},
	computed: {
		getMarkerCoordinates() {
			let latlng = false;
			if (this.detail_data.poi_longitude && this.detail_data.poi_latitude) {
				latlng = [this.detail_data.poi_latitude, this.detail_data.poi_longitude];
			}
			return latlng;
		},
	},
	watch: {
		getMarkerCoordinates(latlng) {
			if (latlng) {
				this.fitbounds++;
			}
		},
	},
	created() {
		this.getPoiDetailTurisem();
	},
	mounted() {
		if (localStorage.turisem_point_detail) {
			this.turisem_point_detail = localStorage.turisem_point_detail;
		}
		this.$store.state.active_loader = true;
	},
	methods: {
		// Todo Remove this function
		getImageArrayTemp() {
			return this.detail_data.poi_simg_src != undefined
				? this.detail_data.poi_simg_src.replace('show_image.php', 'show_image.php')
				: null;
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getLangTypeToUse() {
			return this.$store.state.type_language;
		},
		getPoiDetailTurisem() {
			this.turizem_point_id == undefined ? (this.turizem_point_id = localStorage.turisem_point_detail) : null;

			poi.getPoiTurisem(this.turizem_point_id, this.getLangTypeToUse())
				.then((response) => {
					this.hopper_view_detail += 1;
					this.detail_data = response;
					if (this.$refs.map_in_turisem_detail != null) {
						var marker = (this.$refs.map_in_turisem_detail.leaflet_map.marker = [
							parseFloat(this.detail_data.poi_latitude),
							parseFloat(this.detail_data.poi_longitude),
						]);
					}
					if (response.poi_bimg_src == '' && response.poi_simg_src == '') {
						this.have_images_in_point = false;
						this.set_style = 'margin-top:35px !important';
					}

					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
				});
		},
	},
};
</script>

<style lang="scss" src="./TurisemDetail.scss"></style>
